export var transformHighlightedToGenericAndAppend = function transformHighlightedToGenericAndAppend(block, genericBlocks) {
  return genericBlocks;
};